import Vue from "vue"
import { AclInstaller, AclCreate, AclRule } from "vue-acl"
import router from "@/router"

Vue.use(AclInstaller)

let initialRole = "public"

const getUserStorage = () =>{
  if(localStorage.getItem("userInfo")){
    return JSON.parse(localStorage.getItem("userInfo"))
  } else if (sessionStorage.getItem("userInfo")){
    return JSON.parse(sessionStorage.getItem("userInfo"))
  } else {
    return {}
  }
}

let userInfo = getUserStorage()
if(userInfo && userInfo.userRole) initialRole = userInfo.userRole

export default new AclCreate({
  initial: initialRole,
  notfound: "/pages/not-authorized",
  router,
  acceptLocalRules: true,
  globalRules: {
    superAdmin: new AclRule("superAdmin").generate(),
    admin: new AclRule("admin").or("superAdmin").generate(),
    vip: new AclRule("vip").or("admin").or("superAdmin").generate(),
    premium: new AclRule("premium").or("vip").or("admin").or("superAdmin").generate(),
    editor: new AclRule("editor").or("premium").or("vip").or("admin").or("superAdmin").generate(),
    public: new AclRule("public").or("editor").or("premium").or("vip").or("admin").or("superAdmin").generate(),
  }
})
